var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"login",staticClass:"login-page"},[(_vm.success)?_c('van-row',[_c('van-col',{staticClass:"vant-main",attrs:{"span":"20","offset":"2"}},[_c('van-icon',{attrs:{"name":"success","color":"#5daf34"}}),_vm._v(" "),_c('p',[_vm._v("恭喜您已成功绑定微信，此微信将作为您账号佣金提现的唯一微信，若要更换微信，请在PC后台解绑后，重新进行微信绑定")])],1)],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63d59fce","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/wxbind.vue
// module id = null
// module chunks = 